import type { IconData } from '../../types';

export const data: IconData = {
  o: '<mask id="a" width="26" height="26" x="-1" y="-1" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M-1-1h26v26H-1z"/></mask><g mask="url(#a)"><path fill="currentColor" d="M11 23v-4l-1 1-1-1 3-4 4 4-2 1-1-1v4h-2Zm-5-7-2-2 1-1H1v-2h4l-1-1 2-1 3 3-3 4Zm13 0-4-4 4-3 1 1-1 1h4v2h-4l1 1-1 2Zm-7-2-1-1v-2h2l1 1-1 1-1 1Zm0-5L9 6l1-2 1 1V1h2v4l1-1 2 2-4 3Z"/></g>',
  f: '<mask id="a" width="26" height="26" x="-1" y="-1" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M-1-1h26v26H-1z"/></mask><g mask="url(#a)"><path fill="currentColor" d="M11 23v-4l-1 1-1-1 3-4 4 4-2 1-1-1v4h-2Zm-5-7-2-2 1-1H1v-2h4l-1-1 2-1 3 3-3 4Zm13 0-4-4 4-3 1 1-1 1h4v2h-4l1 1-1 2Zm-7-2-1-1v-2h2l1 1-1 1-1 1Zm0-5L9 6l1-2 1 1V1h2v4l1-1 2 2-4 3Z"/></g>',
  vb: '-1 -1 26 26',
  rao: { fill: 'none' },
  raf: { fill: 'none' },
};

export default data;
